import React from "react";
import { Link } from "react-router-dom";

export default function Welcome() {

    return (
        <div className='flexColumn justifyStart' style={{minHeight: '300px', width: '450px'}}>
            <div style={{marginTop: '20px'}}>Welcome to Whalewatcher</div>
            <div>Watch the whale accounts on the blockchain.</div>
            <div>For Solana and Etherem</div>

            <div className='flexRow' style={{marginTop: '20px'}}>
                <Link to='/solana' ><button className='blueButton'>SOLANA WHALES</button></Link>
                <Link to='/ethereum' ><button className='blueButton'>EHTEREUM WHALES</button></Link>
            </div>
        </div>
    )
}
